'use strict';
import * as $j_app$002edata$002e$002dOrganization$002dAbout$002dUs$002dBlurb$0024package$0024$002dOrganization$002dAbout$002dUs$002dBlurb$0024 from "./app.data.-Organization-About-Us-Blurb$package$-Organization-About-Us-Blurb$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$() {
  this.aCc = null;
  this.aCt = null;
  this.aCf = null;
  this.aCg = false;
  this.aCl = null;
  this.aCm = false;
  this.aCr = null;
  this.aCs = false;
  this.aCd = null;
  this.aCe = false;
  this.aCp = null;
  this.aCq = false;
  this.aCn = null;
  this.aCo = false;
  this.aCh = null;
  this.aCi = false;
  this.aCj = null;
  this.aCk = false;
  $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ = this;
  this.aCc = $j_app$002edata$002e$002dOrganization$002dAbout$002dUs$002dBlurb$0024package$0024$002dOrganization$002dAbout$002dUs$002dBlurb$0024.$m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$();
  this.aCt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dOrganization$002dAbout$002dUs$002dBlurb$0024package$0024$002dOrganization$002dAbout$002dUs$002dBlurb$0024.$m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurb$());
}
export { $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ as $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ };
$p = $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$;
/** @constructor */
function $h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$() {
}
export { $h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ as $h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ };
$h_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$.prototype = $p;
$p.eR = (function() {
  return this.aCc;
});
$p.eO = (function() {
  return this.aCt;
});
$p.bW = (function() {
  if ((!this.aCg)) {
    this.aCf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aCg = true;
  }
  return this.aCf;
});
$p.b9 = (function() {
  if ((!this.aCm)) {
    this.aCl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aCm = true;
  }
  return this.aCl;
});
$p.b3 = (function() {
  if ((!this.aCs)) {
    this.aCr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aCs = true;
  }
  return this.aCr;
});
$p.aG = (function() {
  if ((!this.aCe)) {
    this.aCd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aCe = true;
  }
  return this.aCd;
});
$p.az = (function() {
  if ((!this.aCq)) {
    this.aCp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aCq = true;
  }
  return this.aCp;
});
$p.aY = (function() {
  if ((!this.aCo)) {
    this.aCn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aCo = true;
  }
  return this.aCn;
});
$p.bNa = (function() {
  if ((!this.aCi)) {
    this.aCh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "About Us";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aCi = true;
  }
  return this.aCh;
});
$p.bNA = (function() {
  if ((!this.aCk)) {
    this.aCj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aCk = true;
  }
  return this.aCj;
});
var $d_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$, "app.data.OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$", ({
  Ed: 1,
  N: 1
}));
export { $d_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ as $d_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ };
var $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$;
function $m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$() {
  if ((!$n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$)) {
    $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ = new $c_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$();
  }
  return $n_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$;
}
export { $m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ as $m_Lapp_data_OrganizationAboutUsBlurb$package$OrganizationAboutUsBlurbForm$ };
//# sourceMappingURL=app.data.-Organization-About-Us-Blurb$package$-Organization-About-Us-Blurb-Form$.js.map
